export const FORMATING = {
  DEFAULT_DATETIME: 'DD-MM-YYYY HH:mm',
  DEFAULT_DATE: 'DD-MM-YYYY',
  LONG_MONTH: 'MMM-YYYY',
};
